/**
 * Product gallery skeleton: the PHP-rendered .phent-gallery-skeleton overlay
 * covers the gallery until the WC flexslider has initialized (core fades the
 * gallery from opacity 0 to 1) AND the first image has loaded. After init,
 * individual thumbnails/slides that are still streaming in get a shimmer
 * placeholder via .phent-img-loading on their parent.
 */
const skeleton = document.querySelector('.phent-gallery-skeleton');
const gallery = document.querySelector('.single-product div.product .woocommerce-product-gallery');

if (skeleton && gallery) {
  let finished = false;

  const finish = () => {
    if (finished) return;
    finished = true;
    skeleton.classList.add('phent-gallery-skeleton--done');
    setTimeout(() => skeleton.remove(), 400);
  };

  const firstImageReady = new Promise((resolve) => {
    const img = gallery.querySelector('.woocommerce-product-gallery__image img');
    if (!img || (img.complete && img.naturalWidth)) {
      resolve();
      return;
    }
    img.addEventListener('load', resolve, { once: true });
    img.addEventListener('error', resolve, { once: true });
  });

  const galleryInitialized = new Promise((resolve) => {
    if (getComputedStyle(gallery).opacity === '1') {
      resolve();
      return;
    }
    // WC core sets the inline opacity to 1 right after the flexslider boots.
    const observer = new MutationObserver(() => {
      if (gallery.style.opacity === '1') {
        observer.disconnect();
        resolve();
      }
    });
    observer.observe(gallery, { attributes: true, attributeFilter: ['style'] });
  });

  Promise.all([firstImageReady, galleryInitialized]).then(finish);

  // Never trap the page behind a skeleton (slow/failed image source).
  setTimeout(finish, 6000);

  // After init: shimmer each thumbnail/slide that is still loading.
  galleryInitialized.then(() => {
    gallery
      .querySelectorAll('.flex-control-thumbs img, .woocommerce-product-gallery__image img')
      .forEach((img) => {
        if (img.complete && img.naturalWidth) return;
        const box = img.parentElement;
        box.classList.add('phent-img-loading');
        const done = () => box.classList.remove('phent-img-loading');
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      });
  });
}
